import Icon from '../components/Icon.vue'

Icon.register({
  pills: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M112 32c61.9 0 112 50.1 112 112v224c0 61.9-50.1 112-112 112s-112-50.1-112-112v-224c0-61.9 50.1-112 112-112zM160 256v-112c0-26.5-21.5-48-48-48s-48 21.5-48 48v112h96zM299.7 226.3l210.8 210.8c3.5 3.5 3.2 9.4-0.8 12.3-62.5 45.3-150.1 40.4-206.4-15.9s-61.2-143.9-15.9-206.4c2.9-3.9 8.8-4.3 12.3-0.8zM529.5 207.3c56.4 56.3 61.2 143.8 15.9 206.4-2.9 3.9-8.8 4.3-12.3 0.8l-210.8-210.8c-3.5-3.5-3.2-9.4 0.8-12.3 62.5-45.3 150.1-40.4 206.4 15.9z'
      }
    ]
  }
})
